import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pr0014',
    ecrans: ['00-2']
});
